import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import { getAccuracy } from "utilities/number/number";

import { BTInputNumber } from "commonComponents/btWrappers/BTInputNumber/BTInputNumber";
import { type IGridCellRendererParams } from "commonComponents/utilities/AgGridReact/AgGridReact.types";
import { type INumberResponse } from "commonComponents/utilities/Grid/common/columnImplementations/columnCurrency";
import { NumberDisplay } from "commonComponents/utilities/NumberDisplay/NumberDisplay";

function columnNumberInternal(props: IGridCellRendererParams<INumberResponse | undefined>) {
    if (props.node.group) {
        return <>{props.value}</>;
    } else if (props.value?.value) {
        return (
            <div className={cn("ag-col-number", props.className)}>
                <NumberDisplay
                    value={props.value.value}
                    decimalScale={Math.max(0, getAccuracy(props.value.value))}
                />
            </div>
        );
    } else {
        return null;
    }
}

function columnNumberEditInternal(props: IGridCellRendererParams<INumberResponse | undefined>) {
    if (props.node.group) {
        return <>{props.value}</>;
    } else if (props.value) {
        return (
            <BTInputNumber<undefined>
                min={-Infinity}
                max={Infinity}
                id={`ag-col-number-editor.${props.colDef!.field!}.${props.node.rowIndex!}`}
                data-testid="ag-col-number-editor"
                value={props.value.value}
                precision={props.value.scale}
                onChange={() => {}}
                className={cn("ag-col-number-editor", props.className)}
            />
        );
    }
    return null;
}

export const columnNumber = memo(columnNumberInternal);
export const columnNumberEdit = memo(columnNumberEditInternal);
